import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import template from 'scoreboard/datasets/edit/link-datasets-confirm-prompt.hbs'
import FormView from 'scoreboard/components/form-view'
import highlight from 'scoreboard/components/highlight'

const LinkDatasetsConfirmPrompt = ConfirmPrompt.extend({

	className: 'detailed-confirm-prompt dialog-message',

	// to override the the base ConfirmPrompt's title, which shows in the body
	detailed: true,

	/**
	 * @param {object} options
	 * @param {object} options.validationException
	 * @param {string} options.validationException.preludeCode
	 * @param {string[]} options.validationException.preludeArgs
	 * @param {string} options.validationException.postludeCode
	 * @param {string[]} options.validationException.postludeArgs
	 */
	initialize: function(options = {}) {
		ConfirmPrompt.prototype.initialize.apply(this, arguments)
	},

	render: function() {
		const preludeArgs = _.map(this.options.validationException.preludeArgs, arg => highlight(arg))
		const prelude = i18n.get(this.options.validationException.preludeCode, ...preludeArgs)
		const postludeArgs = _.map(this.options.validationException.postludeArgs, arg => highlight(arg))
		const postlude = i18n.get(this.options.validationException.postludeCode, ...postludeArgs)
		this.options.message = FormView.prototype.multiCauseMessage.apply(this, [
			this.options.validationException.problemValues, {
				prelude,
				postlude,
				escapePrelude: false,
				escapePostlude: false
			}])
		ConfirmPrompt.prototype.render.apply(this, arguments)
		const context = ConfirmPrompt.prototype.context.apply(this, arguments)
		this.$el.prepend(template(context))
		return this
	}
})

export default LinkDatasetsConfirmPrompt
LinkDatasetsConfirmPrompt.__filename__ = 'datasets/edit/link-datasets-confirm-prompt.js'
